import httpClient from 'shared/lib/httpClient';

export const uploadFile = async (payload) => {
  const response = await httpClient.post('/files', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response?.data;
};
